import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b2da65a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "QuestionTplSelectorContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "套题选择", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "wbg flex flex-col wd100",
      style: {
        "height": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_LeftGroupList, {
        data: $data.groups,
        onChoose: $options.onChoose,
        groupTitle: "套题列表"
      }, null, 8, ["data", "onChoose"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "opd12 flex flex-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "pd12 wbg"
      }, {
        default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
          "table-id": 2,
          "init-query": {
            'selectMode': true,
            'groupId': $data.groupId
          },
          ref: "tplTable"
        }, {
          subject: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.mapping[data.rowData]), 1)]),
          secondTimeLimit: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.rowData / 60), 1)]),
          operate: _withCtx(data => [_createVNode(_component_el_button, {
            type: "primary",
            style: {
              "width": "100px"
            },
            onClick: $event => $options.choose(data.rowId)
          }, {
            default: _withCtx(() => [_createTextVNode("选择")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 8, ["init-query"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}